import { render, staticRenderFns } from "./addtsxiansuo.vue?vue&type=template&id=71ed5dea&scoped=true&"
import script from "./addtsxiansuo.vue?vue&type=script&lang=js&"
export * from "./addtsxiansuo.vue?vue&type=script&lang=js&"
import style0 from "./addtsxiansuo.vue?vue&type=style&index=0&id=71ed5dea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed5dea",
  null
  
)

export default component.exports